module.exports = __webpack_public_path__ + "img/i4.8832a015.jpg";